import { createContext } from 'react'
import { AppUIState, initialAppUIState } from './reducer/types'

export const AppUIStateContext = createContext<AppUIState>(initialAppUIState)

export const AppUIStateContextProvider = AppUIStateContext.Provider
